import { Record } from 'immutable';

const defaults = {
    photo: null,
    imageData: null,
    selectedImage: null,
    imageWidth: null,
    imageHeight: null,
    binary: null
};

export const PHOTO_PORTRAIT_RATIO = 1.1;

export const getWidthDifferenceToReachRatio = (imageWidth, imageHeight, orientation) => {
    let extraPixels = null;

    switch (orientation) {
        case 'portrait':
            // Solving an equation:
            //
            // PHOTO_PORTRAIT_RATIO = imageHeight / (imageWidth - extraWidth)
            //
            // The extraWidth tells us how many pixels the image is too wide
            // to be classified as a portrait orientated one.
            extraPixels = Math.ceil(-imageHeight / PHOTO_PORTRAIT_RATIO + imageWidth);
            break;
    }

    return extraPixels;
};

class Photo extends Record(defaults) { // eslint-disable-line new-cap

    getImageOrientation () {
        const { imageWidth, imageHeight } = this;
        if (!imageWidth || !imageHeight) { return null; }

        const ratio = imageHeight / imageWidth;
        return ratio > PHOTO_PORTRAIT_RATIO ? 'portrait'
            : ratio < 0.9 ? 'landscape'
            : 'square';
    }
}

export default Photo;



// WEBPACK FOOTER //
// ./src/records/Photo.js